define((require) => {
    "use strict";

    var _        = require("underscore"),
        Backbone = require("backbone");

    /**
     * The model for keeping the zoom property for the preview and the editor.
     *
     * @author Jens Svensson
     * @class ZoomModel
     * @constructor
     */
    return Backbone.Model.extend({
        defaults: {
            scale: 1
        },

        // Scale factor which translates to zoom percentage, 0.25 = 25%, 0.33 = 33 % and so on.
        SCALE_RANGE: [0.25, 0.33, 0.5, 0.67, 0.75, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2, 3, 4],

        scaleUp: function() {
            var index = _.indexOf(this.SCALE_RANGE, this.get("scale")),
                next  = Math.min(this.SCALE_RANGE.length - 1, index + 1);

            this.set("scale", this.SCALE_RANGE[next]);
        },

        scaleDown: function() {
            var index = _.indexOf(this.SCALE_RANGE, this.get("scale")),
                prev  = Math.max(0, index - 1);

            this.set("scale", this.SCALE_RANGE[prev]);
        },

        reset: function() {
            this.set("scale", 1);
        },

        isMaxScale: function() {
            return this.get("scale") === _.last(this.SCALE_RANGE);
        },

        isMinScale: function() {
            return this.get("scale") === _.first(this.SCALE_RANGE);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/ZoomModel.js